import { FunctionComponent } from 'react';
import { RenderingProps } from './shared.types';
import {
  ComponentRendering,
  HtmlElementRendering,
  RouteData,
} from '@sitecore-jss/sitecore-jss-nextjs';

export const getComponentsFromPlaceholder = <
  TRendering extends RenderingProps['rendering'],
  TModel
>(options: {
  placeholder?: Array<TRendering>;
  componentName: string;
  Component: FunctionComponent<TModel>;
  modelFactory: (rendering?: Partial<TRendering>) => TModel;
}) => {
  const { placeholder, componentName, Component, modelFactory } = options;
  return (
    placeholder
      ?.filter((r) => r?.componentName === componentName)
      ?.map((r, idx) => <Component key={idx} {...modelFactory(r)} />) ?? []
  );
};

export const getAllPlaceholdersFromRouteData = (
  routeData: RouteData
): (ComponentRendering | HtmlElementRendering)[] => {
  if (!routeData || !routeData?.placeholders) return [];

  let placeholders: (ComponentRendering | HtmlElementRendering)[] = [];
  let allPlaceholders: (ComponentRendering | HtmlElementRendering)[][][] = [
    Object.values(routeData.placeholders),
  ];

  while (allPlaceholders.length != 0) {
    const subPlaceholders = Object.values(allPlaceholders[0]).flat();

    for (const placeholder of subPlaceholders) {
      if ('placeholders' in placeholder && placeholder?.placeholders)
        allPlaceholders.push(Object.values(placeholder.placeholders));
    }

    placeholders = placeholders.concat(subPlaceholders);

    allPlaceholders = allPlaceholders.slice(1);
  }

  return placeholders;
};
